import { render, staticRenderFns } from "./TransportDock.vue?vue&type=template&id=086f52f0&scoped=true&"
import script from "./TransportDock.vue?vue&type=script&lang=js&"
export * from "./TransportDock.vue?vue&type=script&lang=js&"
import style0 from "./TransportDock.vue?vue&type=style&index=0&id=086f52f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f52f0",
  null
  
)

export default component.exports